import Navigation from 'components/Navigation';

import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Nav } from 'components/common';
import { NavTypes, useNavType } from 'providers/NavBarProvider';
import { Logo } from 'components/common';
import { MARKETING_SITE_URL } from 'config/settings';

const SignupHeader = ({ noNavigation = false }) => {
  useNavType(NavTypes.None);

  const location = useLocation();
  const pathParts = location.pathname.split('/');

  const isLoginPage =
    pathParts[1].toLowerCase() !== 'signup' &&
    pathParts[1].toLowerCase() !== 'invite-parent' &&
    !noNavigation;

  return isLoginPage ? (
    <Navigation
      leftComponent={
        <Nav.Brand to={MARKETING_SITE_URL}>
          <Logo />
        </Nav.Brand>
      }
      rightComponent={
        <Toggle>
          <span className="mr-3">Don't have an account?</span>
          <Button to="/signup" color="primary" outline>
            Sign up
          </Button>
        </Toggle>
      }
    />
  ) : (
    <Navigation
      isLeftLogoDisabled
      leftComponent={null}
      middleComponent={<Logo />}
    />
  );
};

const Toggle = styled.div`
  display: flex;
  width: max-content;
  align-items: center;
`;

export default SignupHeader;
